module.exports = __webpack_public_path__ + "static/WEDDING E&M-97-2e5b50b3cc5dd9a3c93ed8d9c0eb965a.jpg";